// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aq__section { margin-bottom:1rem; padding-bottom:0.5rem; }

.aq__row {
  display:flex; align-items:center; gap:1rem;
  padding:0.95rem 1.25rem;
  border-bottom:1px solid var(--admin-border);
}
.aq__row:last-child { border-bottom:none; }

.aq__row-num {
  width:1.75rem; height:1.75rem; border-radius:50%;
  background:var(--admin-surface); color:var(--admin-muted);
  display:flex; align-items:center; justify-content:center;
  font-size:0.75rem; font-weight:800; flex-shrink:0;
}

.aq__row-info { flex:1 1; min-width:0; }
.aq__row-name { font-size:0.9rem; font-weight:700; color:var(--admin-text); margin:0 0 0.2rem; }
.aq__row-meta {
  display:flex; align-items:center; gap:0.35rem;
  font-size:0.78rem; color:var(--admin-muted); margin:0 0 0.2rem;
}
.aq__row-wait, .aq__row-offer {
  display:flex; align-items:center; gap:0.35rem; flex-wrap:wrap;
  font-size:0.78rem; color:var(--admin-muted); margin:0;
}
.aq__row-offer strong { color:var(--admin-text); }

@media (max-width:640px) {
  .aq__row { flex-wrap:wrap; }
}

/* ── Batch selection controls ── */
.aq__section-head {
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 0.6rem;
  padding: 1.1rem 1.25rem 0.75rem;
}
.aq__batch-controls { display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; }

.aq__checkbox { width: 1.1rem; height: 1.1rem; accent-color: var(--admin-rust); cursor: pointer; flex-shrink: 0; }

.aq__open-warning {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 0.78rem; color: #d97706;
  background: rgba(217,119,6,0.08);
  margin: 0 1.25rem 0.75rem; padding: 0.6rem 0.85rem;
  border-radius: 7px;
}

.aq__select-n-input {
  width: 3.5rem;
  padding: 0.4rem 0.5rem;
  border: 1px solid var(--admin-border);
  border-radius: 6px;
  font-size: 0.82rem;
  text-align: center;
}
.aq__select-n-input:focus { border-color: var(--admin-rust); outline: none; }

/* ── Alumni badge — returning attendee in the eligible list ── */
.aq__alumni-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #b45309;
  background: rgba(217, 119, 6, 0.12);
  padding: 0.1rem 0.4rem;
  border-radius: 99px;
  margin-left: 0.4rem;
  vertical-align: middle;
}
`, "",{"version":3,"sources":["webpack://./src/admin/AdminQueue.css"],"names":[],"mappings":"AAAA,eAAe,kBAAkB,EAAE,qBAAqB,EAAE;;AAE1D;EACE,YAAY,EAAE,kBAAkB,EAAE,QAAQ;EAC1C,uBAAuB;EACvB,2CAA2C;AAC7C;AACA,sBAAsB,kBAAkB,EAAE;;AAE1C;EACE,aAAa,EAAE,cAAc,EAAE,iBAAiB;EAChD,+BAA+B,EAAE,wBAAwB;EACzD,YAAY,EAAE,kBAAkB,EAAE,sBAAsB;EACxD,iBAAiB,EAAE,eAAe,EAAE,aAAa;AACnD;;AAEA,gBAAgB,QAAM,EAAE,WAAW,EAAE;AACrC,gBAAgB,gBAAgB,EAAE,eAAe,EAAE,uBAAuB,EAAE,iBAAiB,EAAE;AAC/F;EACE,YAAY,EAAE,kBAAkB,EAAE,WAAW;EAC7C,iBAAiB,EAAE,wBAAwB,EAAE,iBAAiB;AAChE;AACA;EACE,YAAY,EAAE,kBAAkB,EAAE,WAAW,EAAE,cAAc;EAC7D,iBAAiB,EAAE,wBAAwB,EAAE,QAAQ;AACvD;AACA,wBAAwB,uBAAuB,EAAE;;AAEjD;EACE,WAAW,cAAc,EAAE;AAC7B;;AAEA,mCAAmC;AACnC;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,eAAe,EAAE,WAAW;EAC5B,+BAA+B;AACjC;AACA,sBAAsB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,eAAe,EAAE;;AAExF,gBAAgB,aAAa,EAAE,cAAc,EAAE,+BAA+B,EAAE,eAAe,EAAE,cAAc,EAAE;;AAEjH;EACE,aAAa,EAAE,mBAAmB,EAAE,WAAW;EAC/C,kBAAkB,EAAE,cAAc;EAClC,gCAAgC;EAChC,yBAAyB,EAAE,uBAAuB;EAClD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;AACA,4BAA4B,+BAA+B,EAAE,aAAa,EAAE;;AAE5E,iEAAiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".aq__section { margin-bottom:1rem; padding-bottom:0.5rem; }\n\n.aq__row {\n  display:flex; align-items:center; gap:1rem;\n  padding:0.95rem 1.25rem;\n  border-bottom:1px solid var(--admin-border);\n}\n.aq__row:last-child { border-bottom:none; }\n\n.aq__row-num {\n  width:1.75rem; height:1.75rem; border-radius:50%;\n  background:var(--admin-surface); color:var(--admin-muted);\n  display:flex; align-items:center; justify-content:center;\n  font-size:0.75rem; font-weight:800; flex-shrink:0;\n}\n\n.aq__row-info { flex:1; min-width:0; }\n.aq__row-name { font-size:0.9rem; font-weight:700; color:var(--admin-text); margin:0 0 0.2rem; }\n.aq__row-meta {\n  display:flex; align-items:center; gap:0.35rem;\n  font-size:0.78rem; color:var(--admin-muted); margin:0 0 0.2rem;\n}\n.aq__row-wait, .aq__row-offer {\n  display:flex; align-items:center; gap:0.35rem; flex-wrap:wrap;\n  font-size:0.78rem; color:var(--admin-muted); margin:0;\n}\n.aq__row-offer strong { color:var(--admin-text); }\n\n@media (max-width:640px) {\n  .aq__row { flex-wrap:wrap; }\n}\n\n/* ── Batch selection controls ── */\n.aq__section-head {\n  display: flex; align-items: center; justify-content: space-between;\n  flex-wrap: wrap; gap: 0.6rem;\n  padding: 1.1rem 1.25rem 0.75rem;\n}\n.aq__batch-controls { display: flex; align-items: center; gap: 0.4rem; flex-wrap: wrap; }\n\n.aq__checkbox { width: 1.1rem; height: 1.1rem; accent-color: var(--admin-rust); cursor: pointer; flex-shrink: 0; }\n\n.aq__open-warning {\n  display: flex; align-items: center; gap: 0.5rem;\n  font-size: 0.78rem; color: #d97706;\n  background: rgba(217,119,6,0.08);\n  margin: 0 1.25rem 0.75rem; padding: 0.6rem 0.85rem;\n  border-radius: 7px;\n}\n\n.aq__select-n-input {\n  width: 3.5rem;\n  padding: 0.4rem 0.5rem;\n  border: 1px solid var(--admin-border);\n  border-radius: 6px;\n  font-size: 0.82rem;\n  text-align: center;\n}\n.aq__select-n-input:focus { border-color: var(--admin-rust); outline: none; }\n\n/* ── Alumni badge — returning attendee in the eligible list ── */\n.aq__alumni-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #b45309;\n  background: rgba(217, 119, 6, 0.12);\n  padding: 0.1rem 0.4rem;\n  border-radius: 99px;\n  margin-left: 0.4rem;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
